import ManageTokenService from '@/services/ManageTokenService';
import FormService from '@/services/FormService';
import ShFormGenerator from '@/components/Helpers/ShFormGenerator';
import CustomStyle from '@/components/Common/CustomStyle';
import CancelButton from '@/components/Common/CancelButton';

export default {
  name: 'DynamicForm',

  components: { CancelButton, CustomStyle, ShFormGenerator },

  props: {
    formType: {
      type: String,
      default: 'login',
    },
    params: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      formElements: FormService.generateFormObject(this.params),
      form: {},
      formParams: {},
      isResendVerificationCodeVisible: false,
      timeAfterShowResendVerisiciationCode: 60000,
      veryficationCodeResendState: 'send',
      veryficationResendCodeTexts: {
        send: 'wyślij ponownie kod weryfikacyjny',
        resend: 'kod weryfikacyjny wysłany ponownie',
      },
      formsDetails: {
        login: {
          title: 'Zaloguj się do swojego konta',
          submitButtonText: 'Zaloguj',
          actionType: 'loginToASP',
        },
        registration: {
          title: 'Załóż nowe konto',
          submitButtonText: 'Załóż konto',
          actionType: 'registerToASP',
        },
        change_password: {
          title: 'Pomoc w odzyskiwaniu hasła',
          description: 'Wpisz swój adres e-mail, aby odzyskać hasło. <br>Otrzymasz wiadomość e-mail z instrukcjami. Jeśli masz problemy z odzyskaniem hasła skontaktuj się z nami.',
          submitButtonText: 'Potwierdź adres',
          actionType: 'changePasswordToASP',
        },
        confirm_change_password: {
          title: 'Podaj hasło',
          submitButtonText: 'Zmień hasło',
          actionType: 'confirmChangePasswordToASP',
        },
        verification: {
          title: 'Załóż nowe konto',
          submitButtonText: 'Weryfikuj',
          actionType: 'registerToASP',
        },
      },
    };
  },

  created() {
    this.updateFormsDetails();
  },

  computed: {
    additionalHtml() {
      const currentForm = this.formsCustomDetails.find(form => form.name === this.formType);
      if (!currentForm) return '';

      return currentForm.under_form_html || '';
    },
    formsCustomDetails() {
      return this.$store.getters['global/forms'];
    },
    fromCustomStyle() {
      return this.$store.getters['global/brandTheme'].form;
    },
    additionalStyles() {
      return this.$store.getters['global/brandTheme'].additionalStyles;
    },
    registrationAdditionalData() {
      return this.$store.getters['global/brandRegistrationAdditionalData'];
    },
  },

  mounted() {
    if (this.formType === 'registration') {
      this.formElements = this.formElements.map((item) => {
        if (item.key === 'terms') {
          item.label = this.registrationAdditionalData;
        }
        return item;
      });
    }
  },

  methods: {
    updateFormsDetails() {
      const formTypes = [
        'login', 'registration', 'change_password', 'confirm_change_password',
        'verification',
      ];

      formTypes.forEach((formType) => {
        const currentForm = this.formsCustomDetails.find(form => form.name === formType);
        if (currentForm) {
          this.formsDetails[formType].title = currentForm.title || this.formsDetails[formType].title;
          this.formsDetails[formType].submitButtonText = currentForm.submit_button_text || this.formsDetails[formType].submitButtonText;
        }
      });

      this.formElements.forEach((element, index) => {
        const currentForm = this.formsCustomDetails.find(form => form.name === this.formType);
        if (currentForm && currentForm.fields) {
          const newField = currentForm.fields.find(field => field.key === element.key);
          if (!newField) return;

          if (this.formElements[index].label) this.formElements[index].label = newField.label || this.formElements[index].label;
          if (this.formElements[index].placeholder) this.formElements[index].placeholder = newField.placeholder || this.formElements[index].placeholder;
          if (this.formElements[index].prepend) this.formElements[index].prepend = newField.prepend || this.formElements[index].prepend;
        }
      });
    },

    handleCancelButton() {
      this.formElements = FormService.generateFormObject(this.params);
      this.$store.dispatch('authServicesPoints/changeFormState', 'login');
    },
    handleRemindPasswordSubmit() {
      this.formElements = FormService.generateFormObject([
        'email',
      ]);
      this.$store.dispatch('authServicesPoints/changeFormState', 'change_password');
    },
    handleSubmit(params) {
      const token = ManageTokenService.getTokenFromStorage();
      const gateway = this.$store.getters['authServicesPoints/gateway'];
      const actionType = this.formsDetails[this.formType].actionType;

      if (this.formType !== 'verification' && params.phone_number !== undefined) {
        this.$store.dispatch('authServicesPoints/sendVerificationCode', { params, token, gateway });
        const { model, newForm } = FormService.transformToVerificationCode(params, this.formElements);
        this.form = model;
        this.formParams = params;
        this.formElements = newForm;
        this.updateFormsDetails();
        this.__showResendVerificationCode();
        // eslint-disable-next-line no-useless-return
        return;
      }

      this.$store.dispatch(`authServicesPoints/${actionType}`, { params, token, gateway });
    },
    handleResendCode() {
      if (this.veryficationCodeResendState !== 'send') {
        return false;
      }
      const token = ManageTokenService.getTokenFromStorage();
      const gateway = this.$store.getters['authServicesPoints/gateway'];
      this.$store.dispatch('authServicesPoints/resendVerificationCode', {
        params: this.formParams, token, gateway,
      });
      this.veryficationCodeResendState = 'resend';
      this.__showResendVerificationCode();
      return true;
    },
    __showResendVerificationCode() {
      setTimeout(() => {
        this.isResendVerificationCodeVisible = true;
        this.veryficationCodeResendState = 'send';
      }, this.timeAfterShowResendVerisiciationCode);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/AuthLoginRegisterPage/DynamicForm/component.js